import { formRoutes } from "./formRoutes"
import {
  onlyProcessor,
  onlySupplierProduct,
} from "@/middleware/check-roles"

import Vue from "vue"
import VueRouter from "vue-router"
import auth from "@/middleware/auth"
import checkLogin from "@/middleware/check-login"
import i18n from "@/libs/i18n"
import appUtils from "@/utils/appUtils"

Vue.use(VueRouter)

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/views/Home.vue"),
      meta: {
        // pageTitle: "Home",
        middleware: [auth],
        // breadcrumb: [
        //   {
        //     text: "Home",
        //     active: true,
        //   },
        // ],
      },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/Login.vue"),
      meta: {
        middleware: [checkLogin],
        layout: "full",
      },
    },
    {
      path: "/auto-login",
      name: "auto-login",
      component: () => import("@/views/AutoLogin/index.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/Error404.vue"),
      meta: {
        layout: "full",
      },
    },
    // Orders
    {
      path: "/orders",
      name: "orders",
      component: () => import("@/views/Orders/index.vue"),
      meta: {
        pageTitle: i18n.t("lbl_orders"),
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },
    {
      path: "/order/:id",
      name: "orderDetail",
      component: () => import("@/views/Orders/Detail/orderDetail.vue"),
      meta: {
        pageTitle: i18n.t("lbl_orders_detail"),
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: i18n.t("lbl_orders"),
            active: false,
            to: "/orders",
          },
          {
            text: "lbl_detail",
            active: true,
          },
        ],
      },
    },
    // Orders marketplace
    {
      path: "/orders-market-place",
      name: "orders-market-place",
      component: () => import("@/views/OrdersMarketPlace/index.vue"),
      meta: {
        pageTitle: "Quản lý đơn hàng hóa",
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },
    {
      path: "/orders-market-place/:id",
      name: "orders-market-place-detail",
      component: () => import("@/views/OrdersMarketPlace/Detail/index.vue"),
      meta: {
        pageTitle: i18n.t("lbl_orders_detail"),
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: i18n.t("lbl_orders"),
            active: false,
            to: "/orders-market-place",
          },
          {
            text: "lbl_detail",
            active: true,
          },
        ],
      },
    },
    // Orders Processor
    {
      path: "/orders-processor",
      name: "orders-processor",
      component: () => import("@/views/OrdersProcessor/index.vue"),
      meta: {
        pageTitle: "lbl_required_test_manager",
        middleware: [auth, onlyProcessor],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },
    {
      path: "/orders-processor/:id",
      name: "detail-order-processor",
      component: () => import("@/views/OrdersProcessor/Detail/orderDetail.vue"),
      meta: {
        pageTitle: "lbl_orders_detail",
        middleware: [auth, onlyProcessor],
        breadcrumb: [
          {
            text: "lbl_required_test_manager",
            active: false,
            to: "/orders-processor",
          },
          {
            text: "lbl_detail",
            active: true,
          },
        ],
      },
    },
    // Inventory
    {
      path: "/inventory",
      name: "inventory",
      component: () => import("@/views/Inventory/index.vue"),
      meta: {
        pageTitle: i18n.t("lbl_inventory"),
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },
    // Kho
    {
      path: "/warehouse",
      name: "warehouse",
      component: () => import("@/views/Warehouse/index.vue"),
      meta: {
        pageTitle: i18n.t("lbl_warehouse"),
        middleware: [auth,],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },
    // Product & Services
    {
      path: "/products",
      name: "products",
      component: () => import("@/views/Products/index.vue"),
      meta: {
        pageTitle: i18n.t("lbl_product___services"),
        middleware: [auth,],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },
    {
      path: "/products/add",
      name: "add-product",
      component: () => import("@/views/Products/Add/index.vue"),
      meta: {
        pageTitle: "lbl_add_product",
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: "lbl_product___services",
            active: false,
            to: "/products-marketplace",
          },
          {
            text: "lbl_add_new",
            active: true,
          },
        ],
      },
    },
    {
      path: "/products/:slug",
      name: "update-product",
      component: () => import("@/views/Products/Add/index.vue"),
      meta: {
        pageTitle: "lbl_update_product",
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: i18n.t("lbl_product___services"),
            active: false,
            to: "/products",
          },
          {
            text: "lbl_update_product",
            active: true,
          },
        ],
      },
    },
    // Reports
    {
      path: "/reports",
      name: "reports",
      component: () => import("@/views/Reports/index.vue"),
      meta: {
        pageTitle: "lbl_reports",
        middleware: [auth],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },
    // Analytics
    // {
    //   path: "/analytics",
    //   name: "analytics",
    //   component: () => import("@/views/Analytics/index.vue"),
    //   meta: {
    //     pageTitle: i18n.t("lbl_analytics"),
    //     middleware: [auth],
    //     breadcrumb: [
    //       {
    //         text: "lbl_list",
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // Configs
    {
      path: "/config-definition",
      name: "config-definition",
      component: () => import("@/views/Configs/Definition/index.vue"),
      meta: {
        pageTitle: i18n.t("lbl_delivery_definition_configs"),
        middleware: [auth,],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },
    {
      path: "/config-delivery-status",
      name: "config-delivery-status",
      component: () => import("@/views/Configs/DeliveryStatus/index.vue"),
      meta: {
        pageTitle: i18n.t("lbl_delivery_status_configs"),
        middleware: [auth,],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },
    {
      path: "/config-order-form",
      name: "config-order-form",
      component: () => import("@/views/Configs/OrderForm/index.vue"),
      meta: {
        pageTitle: i18n.t("lbl_required_attachment_configs"),
        middleware: [auth,],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },

    {
      path: "/print-order-form/:id",
      name: "print-order-form",
      component: () => import("@/views/PrintOrderForm/index.vue"),
      meta: {
        middleware: [auth,],
        layout: "full",
      },
    },

    // Product
    {
      path: "/inventory-product",
      name: "inventory-product",
      component: () => import("@/views/Marketplace/InventoryProduct/index.vue"),
      meta: {
        pageTitle: i18n.t("lbl_inventory_product"),
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: i18n.t("lbl_list"),
            active: true,
          },
        ],
      },
    },

    {
      path: "/inventory-product/:id",
      name: "ProductInventoryDetail",
      component: () =>
        import("@/views/Marketplace/InventoryProduct/ProductInventoryDetail.vue"),
      meta: {
        pageTitle: "Chi tiết lô",
        middleware: [auth],
        breadcrumb: [
          {
            text: "Danh sách",
            active: false,
            to: "/inventory-product",
          },
          {
            text: "Chi tiết",
            active: true,
          },
        ],
      },
    },

    /* Marketplace Product List */
    {
      path: "/products-marketplace",
      name: "products-marketplace",
      component: () => import("@/views/ProductsMarketplace/index.vue"),
      meta: {
        pageTitle: i18n.t("lbl_products"),
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: i18n.t("lbl_list"),
            active: true,
          },
        ],
      },
    },
    {
      path: "/products-marketplace/add",
      name: "add-product-marketplace",
      component: () => import("@/views/ProductsMarketplace/Add/index.vue"),
      meta: {
        pageTitle: "lbl_add_product",
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: "lbl_product___services",
            active: false,
            to: "/products-marketplace",
          },
          {
            text: "lbl_add_new",
            active: true,
          },
        ],
      },
    },
    {
      path: "/products-marketplace/update/:id",
      name: "product-update",
      component: () => import("@/views/ProductsMarketplace/Add/index.vue"),
      meta: {
        isEditable: true,
        pageTitle: "lbl_product_detail",
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: "lbl_product___services",
            active: false,
            to: "/products-marketplace",
          },
          {
            text: "lbl_product_detail",
            active: true,
          },
        ],
      },
    },
    {
      path: "/products-marketplace/:id",
      name: "product-detail",
      component: () => import("@/views/ProductsMarketplace/Add/index.vue"),
      meta: {
        pageTitle: "lbl_product_detail",
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: "lbl_product___services",
            active: false,
            to: "/products-marketplace",
          },
          {
            text: "lbl_product_detail",
            active: true,
          },
        ],
      },
    },
    /* End of Marketplace Product List */
    {
      path: "/product-category",
      name: "product-category",
      component: () => import("@/views/Products/index.vue"),
      meta: {
        pageTitle: i18n.t("lbl_product_category"),
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: i18n.t("lbl_list"),
            active: true,
          },
        ],
      },
    },
    {
      path: "/bill-manager/import",
      name: "import",
      component: () => import("@/views/Marketplace/BillManager/importBill.vue"),
      meta: {
        pageTitle: i18n.t("lbl_document_management"),
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: i18n.t("lbl_list_import_bill"),
            active: true,
          },
        ],
      },
    },
    {
      path: "/bill-manager/export",
      name: "export",
      component: () => import("@/views/Marketplace/BillManager/exportBill.vue"),
      meta: {
        pageTitle: i18n.t("lbl_document_management"),
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: i18n.t("lbl_list_export_bill"),
            active: true,
          },
        ],
      },
    },
    {
      path: "/receipt-manager",
      name: "receipt-manager",
      component: () => import("@/views/Marketplace/ReceiptManager/index.vue"),
      meta: {
        pageTitle: i18n.t("lbl_receipt"),
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: i18n.t("lbl_list"),
            active: true,
          },
        ],
      },
    },
    {
      path: "/receipt/:id",
      name: "ReceiptDetail",
      component: () =>
        import("@/views/Marketplace/ReceiptManager/ReceiptDetail.vue"),
      meta: {
        pageTitle: i18n.t("lbl_receipt_detail"),
        middleware: [auth, onlySupplierProduct],
        layout: "full",
      },
    },
    {
      path: "/add-receiving",
      name: "AddReceiving",
      component: () =>
        import("@/views/Marketplace/ReceivingManager/AddReceiving.vue"),
      meta: {
        pageTitle: i18n.t("lbl_add_receiving"),
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: i18n.t("lbl_add_receiving"),
            active: true,
          },
        ],
      },
    },
    {
      path: "/receiving/:id",
      name: "ReceivingDetail",
      component: () =>
        import("@/views/Marketplace/ReceivingManager/ReceivingDetail.vue"),
      meta: {
        pageTitle: i18n.t("lbl_receiving_detail"),
        middleware: [auth, onlySupplierProduct],
        layout: "full",
      },
    },
    {
      path: "/add-saling",
      name: "AddSaling",
      component: () =>
        import("@/views/Marketplace/SalingManager/AddSaling.vue"),
      meta: {
        pageTitle: i18n.t("lbl_add_saling"),
        middleware: [auth, onlySupplierProduct],
        breadcrumb: [
          {
            text: i18n.t("lbl_add_saling"),
            active: true,
          },
        ],
      },
    },

    // config  product 
    {
      path: "/config-specification",
      name: `config-specification`,
      component: () => import("@/views/Configs/Product/specification.vue"),
      meta: {
        pageTitle: i18n.t("lbl_category_management"),
        middleware: [auth,],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },
    {
      path: "/config-dosage-form",
      name: `config-dosage-form`,
      component: () => import("@/views/Configs/Product/dosage-form.vue"),
      meta: {
        pageTitle: i18n.t("lbl_category_management"),
        middleware: [auth,],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },
    {
      path: "/config-unit-manager",
      name: `config-unit-manager`,
      component: () => import("@/views/Configs/Product/unit-manager.vue"),
      meta: {
        pageTitle: i18n.t("lbl_category_management"),
        middleware: [auth,],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },
    {
      path: "/config-category",
      name: `config-category`,
      component: () => import("@/views/Configs/Product/category.vue"),
      meta: {
        pageTitle: i18n.t("lbl_category_management"),
        middleware: [auth,],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },
    {
      path: "/config-manufacture-manager",
      name: `config-manufacture-manager`,
      component: () => import("@/views/Configs/Product/manufacture-manager.vue"),
      meta: {
        pageTitle: i18n.t("lbl_category_management"),
        middleware: [auth,],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },
    {
      path: "/config-brand-manager",
      name: `config-brand-manager`,
      component: () => import("@/views/Configs/Product/brand-manager.vue"),
      meta: {
        pageTitle: i18n.t("lbl_category_management"),
        middleware: [auth,],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },
    {
      path: "/config-provider-manager",
      name: `config-provider-manager`,
      component: () => import("@/views/Configs/Product/provider-manager.vue"),
      meta: {
        pageTitle: i18n.t("lbl_category_management"),
        middleware: [auth,],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },
    {
      path: "/config-origin",
      name: `config-origin`,
      component: () => import("@/views/Configs/Product/origin.vue"),
      meta: {
        pageTitle: i18n.t("lbl_category_management"),
        middleware: [auth,],
        breadcrumb: [
          {
            text: "lbl_list",
            active: true,
          },
        ],
      },
    },

    {
      path: "/saling/:id",
      name: "SalingDetail",
      component: () =>
        import("@/views/Marketplace/SalingManager/SalingDetail.vue"),
      meta: {
        pageTitle: i18n.t("lbl_saling_detail"),
        middleware: [auth, onlySupplierProduct],
        layout: "full",
      },
    },
    {
      path: "*",
      redirect: "error-404",
    },
    ...formRoutes,
  ],
})
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  if (!subsequentMiddleware) return context.next
  return (...parameters) => {
    context.next(...parameters)
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({
      ...context,
      next: nextMiddleware,
    })
  }
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]
    const context = {
      from,
      next,
      router,
      to,
    }
    const nextMiddleware = nextFactory(context, middleware, 1)
    return middleware[0]({
      ...context,
      next: nextMiddleware,
    })
  }
  return next()
})
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg")
  if (appLoading) {
    appLoading.style.display = "none"
  }
})

export default router
